import { faker } from '@faker-js/faker';

import { EMaoMaintenanceBadge, EMaoMaintenanceName } from '#shared';

import { generateAirport } from './locationFixtures';

import type { MaoAircraft, MaoMaintenance } from '#entities';

export const generateMaintenance = (
  aircraft: MaoAircraft,
  maintenanceType: EMaoMaintenanceBadge = faker.helpers.arrayElement(
    Object.values(EMaoMaintenanceBadge),
  ),
): MaoMaintenance => {
  const startDateAndTime =
    new Date().getTime() - faker.number.int({ min: 0, max: 23 * 60 }) * 60000;
  const endDateAndTime = startDateAndTime + 24 * 60 * 60000;
  return {
    ActualStartDateAndTimeUtc: new Date(startDateAndTime).toISOString(),
    ActualStartDateAndTimeUtcUnix: startDateAndTime,
    ActualEndDateAndTimeUtc: new Date(endDateAndTime).toISOString(),
    ActualEndDateAndTimeUtcUnix: endDateAndTime,
    AircraftId: aircraft.Id,
    Id: faker.number.int({ min: 1 }),
    Airport: generateAirport(aircraft.Location),
    MaintenanceType: {
      Name: faker.helpers.arrayElement(Object.values(EMaoMaintenanceName)),
      OpsBoardBadge: maintenanceType,
    },
    ScheduledStartDateAndTimeUtc: new Date(startDateAndTime).toISOString(),
    ScheduledStartDateAndTimeUtcUnix: startDateAndTime,
    ScheduledEndDateAndTimeUtc: new Date(endDateAndTime).toISOString(),
    ScheduledEndDateAndTimeUtcUnix: endDateAndTime,
  };
};
